export default __webpack_public_path__ + "static/media/icon-user.60d780ba.png";